import {useCallback} from "react";
import {useSelector} from "react-redux";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import api from "../../system/api";
import {getStorage} from "../../system/storage";
import {useTranslate} from "../../system/useTranslate";
import Icon from "../../system/components/icon";
import ClearableDropdown from "../../system/components/clearable-dropdown";
import PrimeDatePicker from "../../system/components/prime-date-picker";
import ZofinoDatepicker from "../../system/components/zofino-datepicker";
import DatatableEmptyMessage from "../../system/components/datatable-empty-message";
import PageHeaderButton from "../../pages/components/page-header-button";

// «Smart forms» UI — the ONE file of the app module that knows Zofino (like host-adapter.ts on the server).
// Everything else in src/modules/forms imports Zofino's design-system pieces and services from here only, so the
// module can move to another host by rewriting this file (docs/tasks/38-forms-design-system-and-repo.md).

export {api, getStorage, Icon, ClearableDropdown, PrimeDatePicker, ZofinoDatepicker, DatatableEmptyMessage, PageHeaderButton};
export const PERSIAN_RANGE_CONFIG = {calendar: persian, locale: persian_fa, range: true};

export const currentWorkspace = () => getStorage("workspace");

// translate with {{name}} placeholders: t("forms.validation.min", {n: 3})
export function useT() {
    const translate = useTranslate();
    return useCallback((key, params) => {
        let text = translate(key);
        if (params) Object.entries(params).forEach(([name, value]) => { text = text.split(`{{${name}}}`).join(String(value ?? "")); });
        return text;
    }, [translate]);
}

// numbers and dates in the app's language (Persian digits and calendar for fa)
export function useFormat() {
    const language = useSelector((state) => state.app.config?.language) || "fa";
    const locale = language === "fa" ? "fa-IR" : "en-US";
    const number = useCallback((value) => (value === null || value === undefined || value === "" || Number.isNaN(Number(value)) ? "—" : Number(value).toLocaleString(locale)), [locale]);
    const date = useCallback((value, withTime = true) => {
        if (!value) return "—";
        const parsed = new Date(value);
        if (Number.isNaN(parsed.getTime())) return "—";
        return parsed.toLocaleString(locale, {timeZone: "Asia/Tehran", year: "numeric", month: "long", day: "numeric", ...(withTime ? {hour: "2-digit", minute: "2-digit"} : {})});
    }, [locale]);
    return {number, date, locale};
}

// shared pass-through for small dropdowns, as in the customers pages
export const DROPDOWN_PT = {input: () => ({className: "text-xs"}), item: () => ({className: "text-xs"})};
